<template>
    <form v-show="isInputFormActive" method="POST">
        <div class="row">
            <div class="col-lg-4 col-md-4 col-12">
                <div class="form-group">
                    <label for="itemname">{{ localizationStore.translate("credit.bureau") }}</label>
                    <select
                        v-model="selectedCreditBureauId"
                        @change="getCreditBureauList(selectedCreditBureauId)"
                        id="creditbureau"
                        name="creditbureau"
                        class="form-control"
                        :class="{'is-invalid' : creditBureauError}"
                        required
                    >
                        <option v-for="creditBureau in creditBureaus" v-bind:value="creditBureau.id">{{ creditBureau.name }}</option>
                    </select>
                    <span v-if="creditBureauError" class="invalid-feedback" role="alert">
                        <strong>Field is Required</strong>
                    </span>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-12">
                <div class="form-group">
                    <label>&nbsp;</label>
                    <br />
                    <button @click="submitForm" type="button" class="btn btn-outline-primary btn-submit"> Dispute Selected Items</button>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-12">
                <!-- search input -->
                <div class="custom-search d-flex justify-content-end">
                    <div class="form-group">
                        <label>&nbsp;</label>
                        <div class="d-flex align-items-center">
                            <label class="mr-1">Search</label>
                            <input
                                v-model="searchTerm"
                                placeholder="Search"
                                type="text"
                                class="d-inline-block form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <vue-good-table
      v-show="isInputFormActive"
      ref="inquiry-table"
      v-on:selected-rows-change="creditorSelectionChanged"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }"
      :select-options="{
        enabled: true,
        disableSelectInfo: true,
        selectOnCheckboxOnly: true
      }"
    >
        <template #table-row="props">
            <span v-if="props.column.field === 'action'">
                <div class="d-flex align-items-center col-actions">
                    <a class="mr-1 text-primary" data-toggle="tooltip" data-placement="top" title="Individual Dispute">
                        <vue-feather type="send" @click="dispute(props.row.id)"></vue-feather>
                    </a>
                </div>
            </span>
        </template>
    </vue-good-table>
    <section v-show="!isInputFormActive">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <a class="go-back" @click="goBack" >{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                        <div class="card-body">
                            <form :action="routes.createLetterRoute" method="post" enctype="multipart/form-data" class="row">
                                <input type="hidden" name="_token" :value="csrf">
                                <input type="text" class="form-control" id="creditbureau" name="creditbureau" :value="selectedCreditBureauId" hidden>
                                <div class="col-md-6 pl-md-0 pr-md-3">
                                    <div id="editor">
                                    </div>
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" type="submit" name="editorType" value="1">
                                            {{ localizationStore.translate("letter.left.submit.button.text") }}
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-6 pl-md-3 pr-md-0 mt-3 mt-md-0">
                                    <div class="arrow-btn">
                                        <button
                                            class="btn btn-outline-primary px-50"
                                            @click="$refs.spinner.spinLetter()"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("spin.letter.button.text") }}
                                            <i data-feather="arrow-right"></i>
                                        </button>
                                    </div>
                                    <div id="editor-right">
                                    </div>
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" type="submit" name="editorType" value="2">
                                            {{ localizationStore.translate("letter.right.submit.button.text") }}
                                        </button>
                                    </div>
                                </div>
                                <spinner ref="spinner" :user-info='userInfo' :editor-ref='editorRef' />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div ref="editorRefSingle" hidden>
            <div class="page">
                <strong>Date:</strong> {{ userInfo.tdate }}
                <br />
                <br />
                <p>
                    <template v-if="isCreditBureauSelected">
                        {{ selectedCreditBureau.address_name }} <br />
                        {{ selectedCreditBureau.street_address }} <br />
                        {{ selectedCreditBureau.city }}, {{ selectedCreditBureau.state_abbrev }}
                        {{ selectedCreditBureau.zipcode }}
                    </template>
                </p>
                <p>
                    <template v-if="isCreditBureauSelected">
                        <strong>Attn:</strong> {{selectedCreditBureau.officers}} <br />
                        <!-- <strong>TO:</strong> {{ selectedCreditBureau.name }} and {{selectedCreditBureau.officers}} -->
                    </template>
                </p>
                <p class="letter-content">
                    RE: Your Company Violated 15 U.S. Code § 1681b - Permissible purposes of consumer reports
                </p>
                <p>
                    <strong>Notice,</strong><template class="letter-content">according to</template> 15 U.S. Code § 1681b - Permissible purposes of consumer reports
                    <strong>(a)In general</strong> Subject to subsection (c), any consumer reporting agency may furnish a consumer report under the following circumstances and no other:
                </p>
                <p>
                    <strong>(2)</strong> In accordance with the written instructions of the consumer to whom it relates.
                </p>
                <p class="letter-content">
                    Under 15 U.S. Code 1681b Permissible purposes of consumer reports I never gave you any written consent to report anything on my consumer report.
                </p>
                <p class="letter-content">
                    For the record, I am a consumer and by law the account in this letter must be <strong><u>DELETED</u></strong> immediately or I will seek monetary damages in small claims court in my city and state.
                    Also we already involved and sent this letter to the Consumer Financial Protection Bureau, Attorney General’s Office, Better Business Bureau, and Federal Trade Commission.
                </p>
                <p v-if="selectedCreditor.length > 0">
                    <strong>NAME OF ACCOUNT:</strong> {{ selectedCreditor[0].furnisher_name }}
                    <br />
                    <template v-if="selectedCreditor[0].reference_number">
                        <strong>REFERENCE NUMBER: </strong>{{ selectedCreditor[0].reference_number }}<br />
                    </template>
                    <template v-else>
                        <strong>ACCOUNT NUMBER: </strong>{{ selectedCreditor[0].account_number }}<br>
                    </template>
                </p>
                <p style="page-break-after: always;">
                    Sincerely,
                    <br />
                    <br />
                    {{ userInfo.firstname }} {{ userInfo.lastname }}
                </p>
            </div>
        </div>
        <div ref="editorRefMultiple" hidden>
            <div class="page">
                <strong>Date:</strong> {{ userInfo.tdate }}
                <br />
                <br />
                <p>
                    <template v-if="isCreditBureauSelected">
                        {{ selectedCreditBureau.address_name }} <br />
                        {{ selectedCreditBureau.street_address }} <br />
                        {{ selectedCreditBureau.city }}, {{ selectedCreditBureau.state_abbrev }}
                        {{ selectedCreditBureau.zipcode }}
                    </template>
                </p>
                <p>
                    <template v-if="isCreditBureauSelected">
                        <strong>Attn:</strong> {{selectedCreditBureau.officers}} <br />
                        <!-- <strong>TO:</strong> {{ selectedCreditBureau.name }} and {{selectedCreditBureau.officers}} -->
                    </template>
                </p>
                <p class="letter-content">
                    RE: Your Company Violated 15 U.S. Code § 1681b - Permissible purposes of consumer reports
                </p>
                <p>
                    <strong>Notice,</strong><template class="letter-content">according to</template> 15 U.S. Code § 1681b - Permissible purposes of consumer reports
                    <strong>(a)In general</strong> Subject to subsection (c), any consumer reporting agency may furnish a consumer report under the following circumstances and no other:
                </p>
                <p>
                    <strong>(2)</strong> In accordance with the written instructions of the consumer to whom it relates.
                </p>
                <p class="letter-content">
                    Under 15 U.S. Code 1681b Permissible purposes of consumer reports I never gave you any written consent to report anything on my consumer report.
                </p>
                <p class="letter-content">
                    For the record, I am a consumer and by law the following accounts in this letter must be <strong><u>DELETED</u></strong> immediately or I will seek monetary damages in small claims court in my city and state.
                    Also we already involved and sent this letter to the Consumer Financial Protection Bureau, Attorney General’s Office, Better Business Bureau, and Federal Trade Commission.
                </p>
                <template v-for="creditor in selectedCreditor">
                    <strong>NAME OF ACCOUNT:</strong> {{ creditor.furnisher_name }}
                    <br />
                    <template v-if="creditor.reference_number">
                        <strong>REFERENCE NUMBER: </strong>{{ creditor.reference_number }}
                        <br />
                    </template>
                    <template v-else>
                        <strong>ACCOUNT NUMBER: </strong>{{ creditor.account_number }}
                        <br />
                    </template>
                    <br />
                </template>
                <p style="page-break-after: always;">
                    Sincerely,
                    <br />
                    <br />
                    {{ userInfo.firstname }} {{ userInfo.lastname }}
                </p>
            </div>
        </div>
    </section>
</template>
<script>
  import { reactive, computed, ref } from 'vue'
  import 'vue-good-table-next/dist/vue-good-table-next.css'
  import { VueGoodTable } from 'vue-good-table-next';
  import { useLocalizationStore } from '../../stores/LocalizationStore.js'
  export default {
    props: {
        csrf: {
            type: String
        },
        propCreditBureaus: {
            type: [Array, Object]
        },
        userInfo: {
            type: [Array, Object]
        },
    },
    components: {
        VueGoodTable,
    },
    setup(props) {
        return {
            creditBureaus: props.propCreditBureaus,
            selectedCreditBureauId: ref(props.propCreditBureaus[0].id),
            editorRefSingle: ref(null),
            editorRefMultiple: ref(null),
            isInputFormActive: ref(true),
            creditBureauError: ref(false),
            date: ref(null),
            editorRef: ref(null),
            localizationStore: useLocalizationStore()
        };
    },
    data(){
        const selectedCreditor = reactive([]);
        return {
          columns: [
            {
              label: 'CREDITOR',
              field: 'furnisher_name',
            },
            {
              label: 'ACCOUNT NUMBER',
              field: 'account_number',
            },
            {
              label: 'PAYMENT STATUS',
              field: 'payment_status',
            },
            {
              label: 'Action',
              field: 'action',
            }
          ],
          rows: [],
          searchTerm: '',
          selectedCreditor
        };
    },
    created() {
        // console.log(this.creditBureaus);
    },
    mounted() {
        axios.get(this.routes.currentDate).then(response => (this.date = response.data));
        this.getCreditBureauList(this.selectedCreditBureauId);
    },
    computed: {
        // a computed getter
        selectedCreditBureau() {
            return this.creditBureaus.find((attribute) => {
                if (attribute.id == this.selectedCreditBureauId) {
                    return attribute;
                }
            })
        },
        isCreditBureauSelected() {
            return (this.selectedCreditBureauId == null || this.selectedCreditBureauId == "null") ? false : true;
        }
    },
    methods: {
      submitForm: function () {
        if (this.validate()) {
            this.editorRef = this.editorRefMultiple;
            this.selectedCreditor = this.$refs['inquiry-table'].selectedRows;
            tinymce.get('editor').setContent(this.editorRefMultiple.innerHTML);
            this.isInputFormActive = !this.isInputFormActive;
        }
      },
      dispute: function (id) {
        this.selectedCreditor[0] = this.rows.find((attribute) => {
            if (attribute.id == id) {
                return attribute;
            }
        });
        this.editorRef = this.editorRefSingle;
        setTimeout(() => {
            tinymce.get('editor').setContent(this.editorRefSingle.innerHTML);
            this.isInputFormActive = !this.isInputFormActive;
        }, "100");
      },
      goBack: function () {
        this.isInputFormActive = !this.isInputFormActive;
      },
      validate: function () {
        if (this.selectedCreditBureauId == null || this.selectedCreditBureauId == "null") {
            this.creditBureauError = true;
        }
        else {
            this.creditBureauError = false;
        }
        return !this.creditBureauError;
      },
      getCreditBureauList: function (type) {
        axios.get(this.routes.listCreditBureau.replace(':type', type)).then(response => {
                this.rows = response.data.data
            }
        );
      },
      creditorSelectionChanged: function (params) {
        this.selectedCreditor = params.selectedRows;
      }
    }
  };
</script>
